module.exports = __webpack_public_path__ + "img/icon-ekyc-detail-driver-license.11fffd0.svg";